import React from 'react'
import SwapPageComponent from '../components/swap'

function QuickSwapPage() {
  return (
    <div><SwapPageComponent/></div>
  )
}

export default QuickSwapPage